import React from "react";
import { Link } from "react-router-dom";
import styles from "./Test.module.scss";

const Test = () => {
  return (
    <div className={styles.container}>
      <h2>Screens</h2>
      <ul>
        <Link to="/" target={"_blank"}>
          <li>Home</li>
        </Link>
        <Link to="/auth/login" target={"_blank"}>
          <li>Login</li>
        </Link>
        <Link to="/auth/register" target={"_blank"}>
          <li>Register</li>
        </Link>
        <Link to="/auth/forgot" target={"_blank"}>
          <li>Forgot Password</li>
        </Link>
        <Link to="/auth/change-password" target={"_blank"}>
          <li>Change Password</li>
        </Link>
        <Link to="/settings" target={"_blank"}>
          <li>Settings</li>
        </Link>
        <Link to="/explore-collection" target={"_blank"}>
          <li>Collection Details</li>
        </Link>
        <Link to="/item" target={"_blank"}>
          <li>NFT Detail</li>
        </Link>
        <Link to="/profile" target={"_blank"}>
          <li>Profile</li>
        </Link>
        <Link to="/edit-profile" target={"_blank"}>
          <li>Edit Profile</li>
        </Link>
        <Link to="/subscription-plans" target={"_blank"}>
          <li>Subscription Plans</li>
        </Link>
        <Link to="/order-summary" target={"_blank"}>
          <li>Order Summary</li>
        </Link>
        <Link to="/payments" target={"_blank"}>
          <li>Payments</li>
        </Link>
        <Link to="/add-new-card" target={"_blank"}>
          <li>Add New Card</li>
        </Link>
        <Link to="/edit-card" target={"_blank"}>
          <li>Edit Card</li>
        </Link>
        <Link to="/create-collection" target={"_blank"}>
          <li>Create Collection</li>
        </Link>
        <Link to="/upload-nft" target={"_blank"}>
          <li>Upload NFT</li>
        </Link>
        <Link to="/subscription" target={"_blank"}>
          <li>Subscription</li>
        </Link>
        <Link to="/terms" target={"_blank"}>
          <li>Terms & Conditions</li>
        </Link>
        <Link to="/privacy" target={"_blank"}>
          <li>Privacy & Policy</li>
        </Link>
        <Link to="/contact" target={"_blank"}>
          <li>Contact Us</li>
        </Link>
        <Link to="/about" target={"_blank"}>
          <li>About Us</li>
        </Link>
      </ul>
    </div>
  );
};

export default Test;
